import {getLeftToLeft, getTopToTop} from "../../../../domain/composition";
import {getLidSize, getCombinedLidSize} from "../../../../domain/lid";
import {getIntermediateCeilingSize} from "../../../../domain/intermediateCeiling";
import {getVaultSize} from "../../../../domain/vault";
import {Manhole, Plan} from "../../../../../types";

export interface LidGeometry {
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;

    clearLeft: number;
    clearRight: number;
    clearFront: number;
    clearBack: number;
    clearLength: number;
    clearWidth: number;

    vaultLeft: number;
    vaultRight: number;
    vaultFront: number;
    vaultBack: number;
}

const round = (val: number) => Math.round(100 * val) / 100

export function createLidGeometry(plan: Plan, manholes: Manhole[], scale: number): LidGeometry {
    const getLidTop = () =>
        !!plan.intermediateCeiling ?
            (getTopToTop(
                (plan: Plan) => getLidSize(plan, manholes),
                [getCombinedLidSize, getIntermediateCeilingSize],
                plan)) * scale :
            plan.lid.type === 'subfloor' && !!plan.vault ?
                (getTopToTop(
                    getLidSize,
                    [getLidSize, (plan: Plan) => getVaultSize(plan, false)],
                    plan
                )) * scale :
                0
    const getLidHeight = () => getLidSize(plan, manholes).width * scale
    const getLidBottom = () => getLidTop() + getLidHeight()

    const getLidLeft = () =>
        !!plan.intermediateCeiling
            ? getLeftToLeft(
            (plan: Plan) => getLidSize(plan, manholes),
            [getCombinedLidSize, getIntermediateCeilingSize],
            plan) * scale
            : plan.lid.type === 'subfloor' && !!plan.vault
                ? getLeftToLeft(getLidSize, [getLidSize, (plan: Plan) => getVaultSize(plan, false)], plan) * scale
                : 0
    const getLidWidth = () => getLidSize(plan, manholes).length * scale
    const getLidRight = () => getLidLeft() + getLidWidth()


    const getClearMeasureLeft = () => getLidLeft() - getLidSize(plan, manholes).x * scale
    const getClearMeasureLength = () => plan.length * scale
    const getClearMeasureRight = () => getClearMeasureLeft() + getClearMeasureLength()
    const getClearMeasureFront = () =>
        getLidTop() + (getLidSize(plan, manholes).width + getLidSize(plan, manholes).y) * scale
    const getClearMeasureWidth = () => plan.width * scale
    const getClearMeasureBack = () => getClearMeasureFront() - getClearMeasureWidth()


    const getVaultLeft = () => round(getClearMeasureLeft() - plan.wallWidth * scale)
    const getVaultRight = () => round(getClearMeasureRight() + plan.wallWidth * scale)
    const getVaultFront = () => round(getClearMeasureFront() + plan.wallWidth * scale)
    const getVaultBack = () => round(getClearMeasureBack() - plan.wallWidth * scale)

    return {
        left: getLidLeft(), right: getLidRight(), top: getLidTop(), bottom: getLidBottom(),
        width: getLidWidth(), height: getLidHeight(),
        clearLeft: getClearMeasureLeft(), clearRight: getClearMeasureRight(),
        clearFront: getClearMeasureFront(), clearBack: getClearMeasureBack(),
        clearLength: getClearMeasureLength(), clearWidth: getClearMeasureWidth(),
        vaultLeft: getVaultLeft(), vaultRight: getVaultRight(),
        vaultFront: getVaultFront(), vaultBack: getVaultBack(),
    };
}